<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">题目</template>
                    {{ detail.title }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">类型</template>
                    {{ detail.question_type_desc }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">状态</template>
                    {{ detail.status_desc }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">添加时间</template>
                    {{ detail.create_time }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form">题目选项</div>
            <el-table
                    :data="detail.option"
                    :row-class-name="tableAddClass"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="options"
                        label="选项"
                        width="100">
                </el-table-column>
                <el-table-column prop="is_answer" label="是否正确答案" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_answer === 1">是</div>
                        <div v-else>否</div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="选项内容">
                </el-table-column>
            </el-table>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { questionDetail } from '@/api/education';

    export default {
        components: {},
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                question_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.question_id = row.question_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save() {
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            getDetail() {
                questionDetail({id: this.question_id}).then((result) => {
                    this.detail = Object.assign({}, result.data)
                })
            },
            tableAddClass({row,rowIndex}) {
                if (row.is_answer === 1) {
                    return 'tr-red';
                }
                return '';
            }

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
    /deep/.el-table .tr-red {
        color: green !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/question/detail.vue